import { Logo } from './Logo'
import { Mail } from 'lucide-react'

const InstagramIcon = ({ className = 'w-4 h-4' }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
)

export function Footer() {
  return (
    <footer className="bg-bone border-t border-taupe/20">
      <div className="container-editorial py-14 md:py-16">
        <div className="grid md:grid-cols-[1.5fr_1fr_1fr_1fr] gap-10 md:gap-12 mb-12">
          <div>
            <Logo className="text-2xl md:text-[26px] text-ink mb-4" />
            <p className="text-sm text-ink/60 leading-relaxed max-w-xs">
              Monitoramento diário de pontos, milhas e bônus.
              Curadoria direta, sem ruído.
            </p>
          </div>

          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-taupe mb-5">Ranking</div>
            <ul className="space-y-2.5 text-sm">
              {[
                ['Top 10 compras', '#compras'],
                ['Melhores milhas', '#milhas'],
                ['Categorias', '#categorias'],
              ].map(([t, h]) => (
                <li key={t}>
                  <a href={h} className="text-ink/75 hover:text-ink transition-colors">{t}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-taupe mb-5">Fontes</div>
            <ul className="space-y-2.5 text-sm">
              <li><a href="https://www.livelo.com.br" target="_blank" rel="noopener" className="text-ink/75 hover:text-ink transition-colors">Livelo</a></li>
              <li><a href="https://www.esfera.com.vc" target="_blank" rel="noopener" className="text-ink/75 hover:text-ink transition-colors">Esfera</a></li>
              <li><a href="https://www.smiles.com.br" target="_blank" rel="noopener" className="text-ink/75 hover:text-ink transition-colors">Smiles</a></li>
              <li><a href="https://latampass.latam.com" target="_blank" rel="noopener" className="text-ink/75 hover:text-ink transition-colors">LATAM Pass</a></li>
              <li><a href="https://www.tudoazul.com" target="_blank" rel="noopener" className="text-ink/75 hover:text-ink transition-colors">Tudo Azul</a></li>
            </ul>
          </div>

          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-taupe mb-5">Contato</div>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a href="mailto:ola@miletomile.com" className="inline-flex items-center gap-2 text-ink/75 hover:text-ink transition-colors">
                  <Mail className="w-3.5 h-3.5" strokeWidth={1.5} />
                  ola@miletomile.com
                </a>
              </li>
              <li>
                <a href="https://instagram.com" className="inline-flex items-center gap-2 text-ink/75 hover:text-ink transition-colors">
                  <InstagramIcon className="w-3.5 h-3.5" />
                  @miletomile
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-taupe/15 flex flex-col md:flex-row md:items-center justify-between gap-3 text-xs text-taupe">
          <div>© {new Date().getFullYear()} mile to mile. Monitoramento informativo — não vendemos milhas nem acessamos contas.</div>
          <div className="flex items-center gap-5">
            <a href="#" className="hover:text-ink transition-colors">Privacidade</a>
            <a href="#" className="hover:text-ink transition-colors">Termos</a>
          </div>
        </div>
      </div>
    </footer>
  )
}
